import { render } from "./VitrineProductGrid.vue?vue&type=template&id=5b249e5c&scoped=true"
import script from "./VitrineProductGrid.vue?vue&type=script&lang=js"
export * from "./VitrineProductGrid.vue?vue&type=script&lang=js"

import "./VitrineProductGrid.vue?vue&type=style&index=0&id=5b249e5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b249e5c"]])

export default __exports__